import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css"; // uses them
import App from "./App";
import { AppThemeProvider } from "./providers/AppThemeProvider";
import { PrayerModeProvider } from "./providers/PrayerModeProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppThemeProvider>
        <PrayerModeProvider>
          <App />
        </PrayerModeProvider>
      </AppThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
